module.exports = __webpack_public_path__ + "static/media/screenshot 1.5b9df736.jpg";